import ConsumersService from "@/services/ConsumersService";
import authService from "@/services/api/AuthService";
import { normalizeStudentCompetitor, normalizeWeeklyPodium } from "@/utils/normalizers";

export default {
    state() {
        return {
            newConsumer: [],
            consumer: [],
            consumersData: [],
            status: null,
            sessionData: [],
            consumerBadges: [],
            studentAchievements: {
                total_xp: 0,
                total_study_hours: 0,
                total_achievements: 0
            },
            weeklyPodium: [],
            studentCompetitor: null,
            studentDashBoardData: [],
            tutorDashBoardData: [],
            tutorMetrics: [],
            studentsMetricsForTutors: [],
            studentsCSVLink: ''
        }
    },

    getters: {
        getStudentsCSVLink: (state) => state.studentsCSVLink,
        getTutorDashBoardData: (state) => state.tutorDashBoardData,
        getStudentsMetricsForTutors: (state) => state.studentsMetricsForTutors,
        getStudentDashBoardData: (state) => state.studentDashBoardData,
        getSessionData: (state) => state.sessionData,
        getConsumerBadges: (state) => state.consumerBadges,
        getStudentTotalXp: (state) => state.studentAchievements.total_xp,
        getStudentTotalStudyHours: (state) => state.studentAchievements.total_study_hours,
        getStudentTotalAchievements: (state) => state.studentAchievements.total_achievements,
        getWeeklyPodium: (state) => state.weeklyPodium,
        getStudentCompetitor: (state) => state.studentCompetitor,
        getTutorMetrics: (state) => state.tutorMetrics,
        getNewConsumerName: (state) => state.newConsumer,
        getConsumerData: (state) => state.consumer,
        getConsumersData: (state) => state.consumersData
    },

    mutations: {
        setStudentsCSVLink(state, data) {
            data && (state.studentsCSVLink = data)
            console.log("Data: ", data)
            console.log("State: ", state.studentsCSVLink)
        },

        setTutorDashBoardData(state, payload) {
            payload && (state.tutorDashBoardData = payload)
        },

        setStudentAchievements(state, payload) {
            state.consumerBadges = payload?.badges ?? []
            state.studentAchievements = {
                total_xp: payload?.total_xp ?? 0,
                total_study_hours: payload?.total_study_hours ?? 0,
                total_achievements: payload?.total_achievements ?? 0
            }
        },

        setWeeklyPodium(state, payload) {
            state.weeklyPodium = payload ?? []
        },

        setStudentCompetitor(state, payload) {
            state.studentCompetitor = payload
        },

        setStudentsMetricsForTutors(state, payload) {
            payload && (state.studentsMetricsForTutors = payload)
        },

        setTutorMetrics(state, response) {
            if (response) {
                state.tutorMetrics = response
            }
        },

        updateTutorWorkLoad(state, data) {
            if (data) {
                state.tutorMetrics.tutor.weekly_hours = data
            }
        },

        setConsumerData(state, data) {
            state.consumer = data;
        },
        setConsumersData(state, data) {
            state.consumersData = data;
            console.log("State: ", state.consumersData)
        },
        setNewConsumer(state, consumer) {
            state.newConsumer = consumer;
        },
        setStatus(state, status) {
            state.status = status;
        },
        setSessionData(state, payload) {
            state.sessionData = payload
        },

        setStudentDashBoardData(state, payload) {
            state.studentDashBoardData = payload
        }
    },

    actions: {
        async getConsumers({ commit }, payload) {
            try {
                const response = await ConsumersService.getConsumers(payload.data, payload.userToken);
                commit('setConsumersData', response.data);
            } catch (error) {
                console.error('Erro ao buscar consumidores', error);

                commit('setStatus', 'Erro ao buscar consumidores');
            }
        },

        async createConsumer({ commit }, payload) {
            try {
                const response = await ConsumersService.createConsumer(payload.consumer, payload.userToken);

                commit('setNewConsumerData', response);

                commit('setStatus', 'Consumidor adicionado com sucesso');
            } catch (error) {
                console.error('Erro ao adicionar consumidor', error);

                commit('setStatus', 'Erro ao adicionar consumidor');
            }
        },

        async getSessionData({ commit, dispatch }, payload) {
            try {
                const response = await ConsumersService.getSessionData(payload)

                switch (payload.type) {
                    case 'Specific User':
                        commit('setSessionData', response.data)
                        break;
                    case 'Students Data For Tutors':
                        commit('setStudentsMetricsForTutors', response.data)
                        break;
                }
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error }, { root: true });
            } finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false }, { root: true })
                }
            }
        },

        async getDashBoardData({ commit, dispatch }, payload) {
            try {
                const response = await ConsumersService.getConsumerDashBoard(payload)
                if (payload.typeAction === 'tutorDashBoardData') {
                    commit('setTutorDashBoardData', response.data)
                    return
                }

                commit('setStudentDashBoardData', response.data)
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error }, { root: true });
            } finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false }, { root: true })
                }
            }
        },

        async getUserAchievements({ commit, dispatch }, payload) {
            try {
                const response = await ConsumersService.getUserAchievements(payload)
                commit('setStudentAchievements', response)
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error }, { root: true });
            } finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false }, { root: true })
                }
            }
        },

        async getWeeklyCompetitionData({ commit, dispatch }, payload) {
            try {
                const podiumResponse = await ConsumersService.getWeeklyPodium(payload)
                commit('setWeeklyPodium', normalizeWeeklyPodium(podiumResponse))

                const competitorResponse = await ConsumersService.getStudentCompetitor(payload)
                commit('setStudentCompetitor', normalizeStudentCompetitor(competitorResponse))
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error }, { root: true });
            } finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false }, { root: true })
                }
            }
        },

        async getTutorMetrics({ commit, dispatch }, payload) {
            try {
                const response = await ConsumersService.getTutorMetrics(payload)
                commit('setTutorMetrics', response)
            } catch (Error) {
                dispatch('toastfy/activeErrorNotification', { text: Error }, { root: true });
            } finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false }, { root: true })
                }
            }
        },

        async setTutorWorkLoad({ commit, dispatch }, payload) {
            try {
                await ConsumersService.setTutorWorkLoad(payload)
                commit('updateTutorWorkLoad', payload.tutorData.weekly_hours)
                dispatch('toastfy/activeSuccesNotification', { text: "Carga horária alterada com sucesso!" }, { root: true });
            } catch (Error) {
                dispatch('toastfy/activeErrorNotification', { text: Error }, { root: true });
            }
        },

        async getStudentsMetricsCSV({ commit, dispatch }, payload) {
            try {
                dispatch('toastfy/activeSuccesNotification', { text: "Gerando Relatório!" }, { root: true });
                const response = await ConsumersService.getStudentCSVMetrics(payload)
                commit('setStudentsCSVLink', response.url)
                dispatch('toastfy/activeSuccesNotification', { text: "Relatório Exportado!" }, { root: true });
            } catch (Error) {
                console.log("Erro Ativado na Store", Error)
                dispatch('toastfy/activeErrorNotification', { text: Error }, { root: true });
            }
        },

        async getStudentsReportRelatedToTutor({ commit, dispatch }, payload) {
            try {
                dispatch('toastfy/activeSuccesNotification', { text: "Gerando Relatório!" }, { root: true });
                await ConsumersService.getStudentsReportRelatedToTutor(payload?.userId || null)
                dispatch('toastfy/activeSuccesNotification', { text: "Relatório Exportado!" }, { root: true });
            } catch (Error) {
                dispatch('toastfy/activeErrorNotification', { text: Error }, { root: true });
            }
        }
    }
}